module.exports = __webpack_public_path__ + "img/avatar-8.35dab8da.jpg";